export default {
  student: null,
  studentBillings: null,
  studentContracts: null,
  studentBills: null,
  studentCards: null,
  states: null,
  cities: null,
  institution: null,
  banks: null,
  reenrollmentContracts: null,
  disallowedReasons: [],
  debtAgreementInputBills: [],
  debtAgreementRules: {},
  levels: [],
  selectedDiscount: {},
  selectedBill: {},
  userPermissions: {},
  recipients: [],
  queroPagoRecipient: null,
  transferDays: [],
  selectedRecipient: null,
  recipientEnums: null,
  interruptionReasons: [],
  selectedBillPayment: null,
};
